import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { AppProviders } from './core/AppProviders'
import { AppShell } from './components/layout/AppShell'
import { RouteFallback } from './components/RouteFallback'
import { HomePage } from './pages/HomePage'
import { SwapPage } from './pages/SwapPage'

const StableSwapPage = lazy(() => import('./pages/StableSwapPage').then((m) => ({ default: m.StableSwapPage })))
const V3LiquidityPage = lazy(() => import('./pages/V3LiquidityPage').then((m) => ({ default: m.V3LiquidityPage })))
const CpmmLiquidityPage = lazy(() => import('./pages/CpmmLiquidityPage').then((m) => ({ default: m.CpmmLiquidityPage })))
const StableLiquidityPage = lazy(() => import('./pages/StableLiquidityPage').then((m) => ({ default: m.StableLiquidityPage })))
const PoolsPage = lazy(() => import('./pages/PoolsPage').then((m) => ({ default: m.PoolsPage })))
const DashboardPage = lazy(() => import('./pages/DashboardPage').then((m) => ({ default: m.DashboardPage })))
const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage').then((m) => ({ default: m.AnalyticsPage })))
const PortfolioPage = lazy(() => import('./pages/PortfolioPage').then((m) => ({ default: m.PortfolioPage })))
const SettingsPage = lazy(() => import('./pages/SettingsPage').then((m) => ({ default: m.SettingsPage })))
const TermsPage = lazy(() => import('./pages/TermsPage').then((m) => ({ default: m.TermsPage })))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })))
const RiskDisclosurePage = lazy(() => import('./pages/RiskDisclosurePage').then((m) => ({ default: m.RiskDisclosurePage })))
const NonCustodialPage = lazy(() => import('./pages/NonCustodialPage').then((m) => ({ default: m.NonCustodialPage })))

export default function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/swap" element={<SwapPage />} />
              <Route path="/swap/stable" element={<StableSwapPage />} />
              <Route path="/liquidity/v3" element={<V3LiquidityPage />} />
              <Route path="/liquidity/cpmm" element={<CpmmLiquidityPage />} />
              <Route path="/liquidity/stable" element={<StableLiquidityPage />} />
              <Route path="/pools" element={<PoolsPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/risk" element={<RiskDisclosurePage />} />
              <Route path="/non-custodial" element={<NonCustodialPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AppProviders>
  )
}
